(function () {
    'use strict';

    angular
        .module('riskSelfAssessmentReviewControllers', ['actionPlanModule',
                                                        'governanceProcessModule',
                                                        'riskModule',
                                                        'services.historyCtxt']);
})();
